import { useState, useEffect } from 'react';
import { ToggleButtonsContainer, ToggleButton } from './styles';

interface ToggleOption {
  label: string;
  value: string;
}

interface ToggleButtonsProps {
  options?: ToggleOption[];
  onChange?: (value: string) => void;
  hasError?: boolean;
}

const ToggleButtons = ({ onChange, options, hasError }: ToggleButtonsProps) => {
  const [selectedButton, setSelectedButton] = useState<number | null>(0);

  const defaultOptions = [
    { label: '1 a 10', value: '1 a 10' },
    { label: '11 a 50', value: '11 a 50' },
    { label: '51 a 100', value: '51 a 100' },
    { label: 'Acima de 100', value: 'Acima de 100' },
  ];

  const buttons = options || defaultOptions;

  useEffect(() => {
    // Dispara o onChange com o valor padrão ao montar o componente
    if (onChange && selectedButton === 0) {
      onChange(buttons[0].value);
    }
  }, []);

  const handleButtonClick = (buttonIndex: number) => {
    setSelectedButton(buttonIndex);

    if (onChange) {
      onChange(buttons[buttonIndex].value);
    }
  };

  return (
    <ToggleButtonsContainer>
      {buttons.map((button, index) => (
        <ToggleButton
          key={index}
          onClick={() => handleButtonClick(index)}
          className={`${selectedButton === index ? 'selected' : ''} ${
            hasError && selectedButton === null ? 'error' : ''
          }`}
        >
          {button.label}
        </ToggleButton>
      ))}
    </ToggleButtonsContainer>
  );
};

export default ToggleButtons;
